export default __webpack_public_path__ + "static/media/Epic Rock (MP3).af5fa09a.mp3";